import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';

@Injectable()
export class DynamicControlValidatorRegistry {
  private registry = new Map<string, ValidatorFn[]>();

  register(propertyBinding: string, ...validators: ValidatorFn[]): void {
    this.registry.set(propertyBinding, validators);
  }

  deregister(propertyBinding: string): void {
    this.registry.delete(propertyBinding);
  }

  get(propertyBinding: string): ValidatorFn[] {
    return this.registry.get(propertyBinding) ?? [];
  }
}
